import { ButtonInfo } from "../items";

// 依頼作成・編集用権限情報model
export class ReceptionEditorPermissions {

  // 一時保存
  public registerTemporary: ButtonInfo;

  // 登録
  public register: ButtonInfo;

  // 登録（依頼書作成）
  public registerAndRequestSheet: ButtonInfo;

  // 依頼書作成
  public requestSheetCreate: ButtonInfo;
}
